import { SingleRadioItemModel } from '@ui-components';

export const contactTopicsConst: SingleRadioItemModel<string>[] = [
  {
    name: 'Pomoc i obsługa',
    value: 'Pomoc i obsługa'
  },
  {
    name: 'Sugestie i pomysły',
    value: 'Sugestie i pomysły'
  },
  {
    name: 'Współpraca, Reklama, Sponsoring, Media',
    value: 'Współpraca, Reklama, Sponsoring, Media'
  },
  {
    name: 'Chcę zostać Organizatorem gierek',
    value: 'Chcę zostać Organizatorem gierek'
  },
  {
    name: 'Inna sprawa',
    value: 'Inna sprawa'
  }
];
